import { render, staticRenderFns } from "./CommonBlockTitle.vue?vue&type=template&id=12e8e606&scoped=true"
import script from "./CommonBlockTitle.vue?vue&type=script&lang=ts"
export * from "./CommonBlockTitle.vue?vue&type=script&lang=ts"
import style0 from "./CommonBlockTitle.vue?vue&type=style&index=0&id=12e8e606&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12e8e606",
  null
  
)

export default component.exports